<div [ngStyle]="{'margin-bottom': !remark ? '1rem' : ''}"  class="input-container">
    <div class="placeholder" [ngClass]="{'float': value}">{{placeholder}}</div>
    <textarea rows="5" [disabled]="disabled" [ngClass]="{'error': error}" [ngStyle]="{'padding-top': value ? '25px': ''}" (change)="onChange($event.target.value)" [(ngModel)]="value"></textarea>
    <div class="remark-container">
        <div class="remark" *ngIf="remark">{{remark}}</div>
        <div class="remark" *ngIf="remark2">{{remark2}}</div>
    </div>
</div>
<span class="error" *ngIf="error">{{error}}</span>